import React from "react";

export enum BrandOrderReviewPageNavigationSource {
  brand_review_source_unknown = "brand_review_source_unknown",
  logged_out_brand_page = "logged_out_brand_page",
  brand_page = "brand_page",
  product_page = "product_page",
  order_page = "order_page",
  orders_page_top_banner = "orders_page_top_banner",
  orders_page_write_review_cta = "orders_page_write_review_cta",
  orders_page_edit_review_cta = "orders_page_edit_review_cta",
  my_reviews_page = "my_reviews_page",
  brand_reviews_page = "brand_reviews_page",
  packaging_slip = "packaging_slip",
  review_brand_email = "review_brand_email",
  review_brand_reminder_email = "review_brand_reminder_email",
}

const DEFAULT_SOURCE =
  BrandOrderReviewPageNavigationSource.brand_review_source_unknown;

export const BrandOrderReviewPageNavigationSourceContext =
  React.createContext<BrandOrderReviewPageNavigationSource>(DEFAULT_SOURCE);

export const useBrandOrderReviewPageNavigationSourceContext = () => {
  return React.useContext(BrandOrderReviewPageNavigationSourceContext);
};
